<a
  #toggle
  class="profile-icon-wrapper"
  href="javascript:void(0)"
  (click)="handleNavItemClick($event, 'mini-profile')">
  <i class="icon-account"></i>
</a>

<app-profile-notification
  *ngIf="notifications?.length"
  [notificationCount]="notifications?.length">
</app-profile-notification>
